export class Agreement_version {
    id: string;
    agreement_type: 'privacy_policy' | 'user_agreement';
    version: string;
    document_url: string;
    effective_date: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export interface AssentStatus {
    all_current: boolean;
    pending: Agreement_version[];
}
